module.exports = __webpack_public_path__ + "img/expostyle_1155_stone_grey.7a44ef19.jpg";